import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import SlidingDrawer from '../components/SlidingDrawer';
import API_BASE_URL from '../api';

const ICONS = {
    search: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>,
    add: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>,
    user: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>,
    id: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="16" rx="2" ry="2"></rect><line x1="7" y1="8" x2="17" y2="8"></line><line x1="7" y1="12" x2="17" y2="12"></line><line x1="7" y1="16" x2="12" y2="16"></line></svg>,
    shield: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /></svg>,
    legislative: <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 21h18" /><path d="M5 21V7l8-4 8 4v14" /><path d="M17 7v14" /><path d="M7 21v-8a4 4 0 0 1 8 0v8" /></svg>,
    admin: <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 7h-3a2 2 0 0 0-2-2h-6a2 2 0 0 0-2 2H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z" /><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" /></svg>
};


const InputField = ({ label, id, value, onChange, placeholder, type = "text", required = false, icon }) => (
    <div style={{ marginBottom: '20px' }}>
        <label style={{ display: 'block', fontSize: '11px', fontWeight: '800', color: '#888', textTransform: 'uppercase', letterSpacing: '1.5px', marginBottom: '8px' }}>
            {label} {required && <span style={{ color: '#C0722C' }}>*</span>}
        </label>
        <div style={{ position: 'relative' }}>
            {icon && (
                <span style={{ position: 'absolute', left: '16px', top: '50%', transform: 'translateY(-50%)', color: '#C0722C', display: 'flex' }}>
                    {icon}
                </span>
            )}
            <input
                id={id}
                type={type}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder={placeholder}
                style={{
                    width: '100%',
                    padding: `14px 16px 14px ${icon ? '48px' : '16px'}`,
                    borderRadius: '12px',
                    border: '1px solid #E0E0E0',
                    fontSize: '14px',
                    color: '#2C1A10',
                    transition: 'all 0.3s ease',
                    boxSizing: 'border-box',
                    backgroundColor: '#F9F9F9'
                }}
                onFocus={(e) => { e.target.style.borderColor = '#C0722C'; e.target.style.backgroundColor = '#fff'; e.target.style.boxShadow = '0 0 0 4px rgba(192, 114, 44, 0.1)'; }}
                onBlur={(e) => { e.target.style.borderColor = '#E0E0E0'; e.target.style.backgroundColor = '#F9F9F9'; e.target.style.boxShadow = 'none'; }}
            />
        </div>
    </div>
);

const SelectField = ({ label, value, onChange, options, placeholder, required = false, onAddNew }) => (
    <div style={{ marginBottom: '20px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
            <label style={{ fontSize: '11px', fontWeight: '800', color: '#888', textTransform: 'uppercase', letterSpacing: '1.5px' }}>
                {label} {required && <span style={{ color: '#C0722C' }}>*</span>}
            </label>
            {onAddNew && (
                <button
                    type="button"
                    onClick={onAddNew}
                    style={{
                        background: 'none',
                        border: 'none',
                        color: '#C0722C',
                        fontSize: '10px',
                        fontWeight: '800',
                        textTransform: 'uppercase',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '4px'
                    }}
                >
                    <span>+ Add New</span>
                </button>
            )}
        </div>
        <select
            value={value}
            onChange={(e) => onChange(e.target.value)}
            style={{
                width: '100%',
                padding: '14px 16px',
                borderRadius: '12px',
                border: '1px solid #E0E0E0',
                fontSize: '14px',
                color: '#2C1A10',
                backgroundColor: '#F9F9F9',
                outline: 'none',
                cursor: 'pointer'
            }}
        >
            <option value="">{placeholder}</option>
            {options.map((opt, idx) => (
                <option key={idx} value={typeof opt === 'string' ? opt : opt.name}>
                    {typeof opt === 'string' ? opt : opt.name}
                </option>
            ))}
        </select>
    </div>
);

const UserManagement = () => {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filter, setFilter] = useState('');
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [roleCategory, setRoleCategory] = useState(null); // 'legislative' or 'administrative'

    const [isEditing, setIsEditing] = useState(false);
    const [selectedUserId, setSelectedUserId] = useState(null);

    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        mobile: '',
        designation: '',
        house: '',
        constituency: '',
        party: '',
        department: ''
    });

    // Master Data State
    const [constituencies, setConstituencies] = useState([]);
    const [parties, setParties] = useState([]);
    const [departments, setDepartments] = useState([]);

    const token = localStorage.getItem('token');
    const api = axios.create({
        baseURL: `${API_BASE_URL}/api`,
        headers: { Authorization: `Bearer ${token}` }
    });

    const fetchData = async () => {
        try {
            const [usersRes, constRes, partyRes, deptRes] = await Promise.all([
                api.get(`/users?search=${filter}`),
                api.get('/master/constituencies'),
                api.get('/master/parties'),
                api.get('/master/departments')
            ]);
            setUsers(usersRes.data);
            setConstituencies(constRes.data);
            setParties(partyRes.data);
            setDepartments(deptRes.data);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [filter]);

    const handleFormSubmit = async (e) => {
        e.preventDefault();

        // Basic Validation
        const requiredFields = ['firstName', 'lastName', 'email', 'mobile', 'designation'];
        if (roleCategory === 'legislative') requiredFields.push('house');

        const missing = requiredFields.filter(f => !formData[f]);
        if (missing.length > 0) {
            Swal.fire('Identity Verification Required', 'Please complete all mandatory identity parameters.', 'warning');
            return;
        }

        // Validate Mobile Format
        const mobileRegex = /^[6-9]\d{9}$/;
        if (!mobileRegex.test(formData.mobile)) {
            Swal.fire('Invalid Format', 'Mobile number must be a valid 10-digit Indian number.', 'warning');
            return;
        }

        try {
            Swal.fire({
                title: isEditing ? 'Updating Registry...' : 'Processing Registry...',
                html: isEditing ? 'Synchronizing profile updates.' : 'Validating clearance and generating secure keys.',
                didOpen: () => Swal.showLoading(),
                allowOutsideClick: false
            });

            if (isEditing) {
                await api.put(`/users/${selectedUserId}`, formData);
            } else {
                await api.post('/users', formData);
            }

            Swal.fire({
                title: isEditing ? 'Profile Updated' : 'Registry Updated',
                text: isEditing ? 'Dignitary identity synchronized successfully.' : 'Personnel successfully onboarded to the matrix.',
                icon: 'success',
                confirmButtonColor: '#C0722C'
            });
            setIsDrawerOpen(false);
            setRoleCategory(null);
            setIsEditing(false);
            setFormData({
                firstName: '', lastName: '', email: '', mobile: '',
                designation: '', house: '', constituency: '', party: '', department: ''
            });
            fetchData();
        } catch (err) {
            Swal.fire('Operation Failed', err.response?.data?.error || 'System Error', 'error');
        }
    };

    const handleEdit = (user) => {
        const isLegis = ['MLA', 'MP', 'MLC', 'Minister', 'Speaker'].includes(user.designation);
        setRoleCategory(isLegis ? 'legislative' : 'administrative');
        setFormData({
            firstName: user.firstName,
            lastName: user.lastName,
            email: user.email,
            mobile: user.mobile,
            designation: user.designation,
            house: user.house || '',
            constituency: user.constituency || '',
            party: user.party || '',
            department: user.department || ''
        });
        setSelectedUserId(user._id);
        setIsEditing(true);
        setIsDrawerOpen(true);
    };

    const toggleStatus = async (user) => {
        const action = user.isActive ? 'Deactivate' : 'Activate';
        let reason = '';

        if (user.isActive) {
            const { value: text } = await Swal.fire({
                input: 'textarea',
                title: 'Revocation Protocol',
                inputPlaceholder: 'Enter legal/security context for access revocation...',
                showCancelButton: true,
                confirmButtonColor: '#D32F2F',
                confirmButtonText: 'Revoke Access',
                cancelButtonText: 'Abort'
            });
            if (!text) return;
            reason = text;
        }

        try {
            await api.patch(`/users/${user._id}/status`, { isActive: !user.isActive, reason });
            Swal.fire({
                title: 'Protocol Executed',
                text: `Clearance status updated for ${user.firstName}.`,
                icon: 'success',
                confirmButtonColor: '#C0722C'
            });
            fetchData();
        } catch (err) {
            Swal.fire('Error', 'Status change failed', 'error');
        }
    };


    const handleAddNewMaster = async (type) => {
        const title = type.charAt(0).toUpperCase() + type.slice(1);
        let htmlContent = '';
        let preConfirmFn = () => { };

        if (type === 'constituency') {
            htmlContent = `
                <input id="swal-name" class="swal2-input" placeholder="Constituency Name">
                <input id="swal-code" class="swal2-input" placeholder="Constituency Code">
                <textarea id="swal-details" class="swal2-textarea" placeholder="Details/Region"></textarea>
            `;
            preConfirmFn = () => ({
                name: document.getElementById('swal-name').value,
                code: document.getElementById('swal-code').value,
                details: document.getElementById('swal-details').value
            });
        } else if (type === 'party') {
            htmlContent = `
                <input id="swal-name" class="swal2-input" placeholder="Party Name">
                <input id="swal-symbol" class="swal2-input" placeholder="Party Symbol/URL">
                <input id="swal-leader" class="swal2-input" placeholder="Party Leader">
            `;
            preConfirmFn = () => ({
                name: document.getElementById('swal-name').value,
                symbol: document.getElementById('swal-symbol').value,
                leader: document.getElementById('swal-leader').value
            });
        } else if (type === 'department') {
            htmlContent = `
                <input id="swal-name" class="swal2-input" placeholder="Department Name">
                <input id="swal-head" class="swal2-input" placeholder="Department Head">
                <textarea id="swal-desc" class="swal2-textarea" placeholder="Description/Jurisdiction"></textarea>
            `;
            preConfirmFn = () => ({
                name: document.getElementById('swal-name').value,
                head: document.getElementById('swal-head').value,
                description: document.getElementById('swal-desc').value
            });
        }

        const { value: formValues } = await Swal.fire({
            title: `Initialize New ${title}`,
            html: htmlContent,
            focusConfirm: false,
            showCancelButton: true,
            confirmButtonColor: '#C0722C',
            cancelButtonColor: '#2C1A10',
            preConfirm: () => {
                const values = preConfirmFn();
                if (!values.name) {
                    Swal.showValidationMessage('Identity Name is required');
                }
                if (type === 'constituency' && !values.code) {
                    Swal.showValidationMessage('Constituency Code is required');
                }
                return values;
            }
        });

        if (formValues) {
            try {
                await api.post(`/master/${type}s`, formValues);
                Swal.fire('Identity Registered', `${title} has been added to the master ledger.`, 'success');
                fetchData();
            } catch (err) {
                Swal.fire('Conflict', 'This entity already exists in the registry.', 'error');
            }
        }
    };

    return (
        <div style={{ maxWidth: '1400px', margin: '0 auto', fontFamily: '"Outfit", sans-serif' }}>
            <style>
                {`
                .custom-input {
                    width: 100%;
                    padding: 16px 20px;
                    border-radius: 12px;
                    border: 1.5px solid #E5E5E5;
                    font-size: 16px;
                    box-sizing: border-box;
                    outline: none;
                    transition: all 0.3s ease;
                    background-color: #FAFAFA;
                    font-family: inherit;
                    color: #333;
                    -webkit-appearance: none;
                    appearance: none;
                }
                .custom-input:focus {
                    border-color: #C0722C;
                    box-shadow: 0 0 0 4px rgba(192, 114, 44, 0.1);
                    background-color: #fff;
                }
                `}
            </style>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px' }}>
                <div>
                    <h1 style={{ margin: '0 0 8px 0', fontSize: '32px', fontWeight: '800', color: '#2C1A10' }}>Identity Registry</h1>
                    <p style={{ margin: 0, color: '#999', fontSize: '16px' }}>Onboard and manage official credentials with Level 4 clearance.</p>
                </div>
                <button
                    onClick={() => { setRoleCategory(null); setIsEditing(false); setIsDrawerOpen(true); }}
                    style={{
                        padding: '16px 32px',
                        backgroundColor: '#2C1A10',
                        color: 'white',
                        border: 'none',
                        borderRadius: '20px',
                        fontWeight: '700',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                        boxShadow: '0 10px 25px rgba(44, 26, 16, 0.2)',
                        transition: 'all 0.3s ease'
                    }}
                    onMouseOver={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                    onMouseOut={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                >
                    {ICONS.add}
                    Initialize Profile
                </button>
            </div>

            <div style={{ position: 'relative', marginBottom: '45px' }}>
                <div style={{ position: 'absolute', left: '16px', top: '50%', transform: 'translateY(-50%)', color: '#C0722C', display: 'flex', zIndex: 2 }}>
                    {ICONS.search}
                </div>
                <input
                    type="text"
                    placeholder="Search by Identity, Secretariat Email or Personnel Code..."
                    value={filter}
                    onChange={(e) => setFilter(e.target.value)}
                    className="custom-input"
                    style={{ paddingLeft: '48px' }}
                />
            </div>

            <SlidingDrawer
                isOpen={isDrawerOpen}
                onClose={() => { setIsDrawerOpen(false); setIsEditing(false); setRoleCategory(null); }}
                title={isEditing ? "Synchronize Personnel Profile" : "Initialize Personnel Profile"}
            >
                {!roleCategory ? (
                    <div style={{ animation: 'fadeIn 0.4s ease' }}>
                        <div style={{ marginBottom: '30px' }}>
                            <div style={{ fontSize: '11px', fontWeight: '800', color: '#C0722C', textTransform: 'uppercase', letterSpacing: '2px', marginBottom: '10px' }}>Protocol Selection</div>
                            <h2 style={{ color: '#2C1A10', margin: 0, fontSize: '24px', fontWeight: '800' }}>Select Classification</h2>
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                            <div
                                onClick={() => { setRoleCategory('legislative'); setFormData({ ...formData, designation: 'MLA' }); }}
                                style={{
                                    padding: '30px',
                                    borderRadius: '24px',
                                    backgroundColor: '#FDF8F3',
                                    border: '1px solid #F0E8DB',
                                    cursor: 'pointer',
                                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    gap: '15px',
                                    textAlign: 'center'
                                }}
                                onMouseOver={(e) => { e.currentTarget.style.borderColor = '#C0722C'; e.currentTarget.style.transform = 'translateY(-5px)'; e.currentTarget.style.boxShadow = '0 15px 30px rgba(192, 114, 44, 0.1)'; }}
                                onMouseOut={(e) => { e.currentTarget.style.borderColor = '#F0E8DB'; e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = 'none'; }}
                            >
                                <div style={{ color: '#C0722C', background: 'white', padding: '15px', borderRadius: '50%', boxShadow: '0 5px 15px rgba(0,0,0,0.05)' }}>
                                    {ICONS.legislative}
                                </div>
                                <div>
                                    <div style={{ fontWeight: '800', color: '#2C1A10', fontSize: '18px', marginBottom: '4px' }}>Legislative Member</div>
                                    <div style={{ fontSize: '13px', color: '#888' }}>MLA, MP, MLC, Speaker, Minister</div>
                                </div>
                            </div>
                            <div
                                onClick={() => { setRoleCategory('administrative'); setFormData({ ...formData, designation: 'Secretariat' }); }}
                                style={{
                                    padding: '30px',
                                    borderRadius: '24px',
                                    backgroundColor: '#F9F9F9',
                                    border: '1px solid #E0E0E0',
                                    cursor: 'pointer',
                                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    gap: '15px',
                                    textAlign: 'center'
                                }}
                                onMouseOver={(e) => { e.currentTarget.style.borderColor = '#2C1A10'; e.currentTarget.style.transform = 'translateY(-5px)'; e.currentTarget.style.boxShadow = '0 15px 30px rgba(0, 0, 0, 0.05)'; }}
                                onMouseOut={(e) => { e.currentTarget.style.borderColor = '#E0E0E0'; e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = 'none'; }}
                            >
                                <div style={{ color: '#2C1A10', background: 'white', padding: '15px', borderRadius: '50%', boxShadow: '0 5px 15px rgba(0,0,0,0.05)' }}>
                                    {ICONS.admin}
                                </div>
                                <div>
                                    <div style={{ fontWeight: '800', color: '#2C1A10', fontSize: '18px', marginBottom: '4px' }}>Administrative Staff</div>
                                    <div style={{ fontSize: '13px', color: '#888' }}>Secretariat, IT, Security</div>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <form onSubmit={handleFormSubmit} style={{ animation: 'fadeIn 0.4s ease' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '25px', cursor: 'pointer' }} onClick={() => setRoleCategory(null)}>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#C0722C" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><line x1="19" y1="12" x2="5" y2="12" /><polyline points="12 19 5 12 12 5" /></svg>
                            <span style={{ fontSize: '12px', fontWeight: '800', color: '#C0722C', textTransform: 'uppercase', letterSpacing: '1px' }}>Change Classification</span>
                        </div>

                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
                            <InputField
                                label="Given Name"
                                icon={ICONS.user}
                                value={formData.firstName}
                                onChange={(val) => setFormData({ ...formData, firstName: val })}
                                placeholder="e.g. Abhis"
                                required
                            />
                            <InputField
                                label="Family Name"
                                value={formData.lastName}
                                onChange={(val) => setFormData({ ...formData, lastName: val })}
                                placeholder="e.g. Kumar"
                                required
                            />
                        </div>

                        <InputField label="Official Email" icon={ICONS.id} value={formData.email} onChange={(val) => setFormData({ ...formData, email: val })} placeholder="person@nic.in" required />
                        <InputField label="Secure Mobile" icon={ICONS.user} value={formData.mobile} onChange={(val) => setFormData({ ...formData, mobile: val })} placeholder="+91 XXXXX XXXXX" required />

                        <div style={{ margin: '20px 0', borderTop: '1px dashed #F0E8DB', paddingTop: '20px' }}>
                            <SelectField
                                label="Designation"
                                value={formData.designation}
                                onChange={(val) => setFormData({ ...formData, designation: val })}
                                placeholder="Select Role"
                                options={roleCategory === 'legislative' ? ['MLA', 'MP', 'MLC', 'Minister', 'Speaker'] : ['Secretariat']}
                                required
                            />

                            {roleCategory === 'legislative' ? (
                                <>
                                    <SelectField
                                        label="Legislative House"
                                        value={formData.house}
                                        onChange={(val) => setFormData({ ...formData, house: val })}
                                        placeholder="Select House"
                                        options={['Vidhan Sabha', 'Vidhan Parishad']}
                                        required
                                    />
                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
                                        <SelectField
                                            label="Constituency"
                                            value={formData.constituency}
                                            onChange={(val) => setFormData({ ...formData, constituency: val })}
                                            placeholder="Select Constituency"
                                            options={constituencies}
                                            onAddNew={() => handleAddNewMaster('constituency')}
                                        />
                                        <SelectField
                                            label="Political Party"
                                            value={formData.party}
                                            onChange={(val) => setFormData({ ...formData, party: val })}
                                            placeholder="Select Party"
                                            options={parties}
                                            onAddNew={() => handleAddNewMaster('party')}
                                        />
                                    </div>
                                    {formData.designation === 'Minister' && (
                                        <SelectField
                                            label="Administrative Department"
                                            value={formData.department}
                                            onChange={(val) => setFormData({ ...formData, department: val })}
                                            placeholder="Select Department"
                                            options={departments}
                                            onAddNew={() => handleAddNewMaster('department')}
                                            required
                                        />
                                    )}
                                </>
                            ) : (
                                <SelectField
                                    label="Administrative Department"
                                    value={formData.department}
                                    onChange={(val) => setFormData({ ...formData, department: val })}
                                    placeholder="Select Department"
                                    options={departments}
                                    onAddNew={() => handleAddNewMaster('department')}
                                />
                            )}
                        </div>

                        <div style={{ padding: '20px', backgroundColor: '#FDF8F3', borderRadius: '16px', border: '1px solid #F0E8DB', marginBottom: '30px', display: 'flex', gap: '12px' }}>
                            <div style={{ color: '#C0722C' }}>{ICONS.shield}</div>
                            <p style={{ margin: 0, fontSize: '13px', color: '#8D5A34', lineHeight: '1.5' }}>
                                <strong>Encryption Protocol:</strong> Automated RSA-key generation will be triggered. Credentials will be dispatched to the official email for activation.
                            </p>
                        </div>

                        <button
                            type="submit"
                            style={{
                                width: '100%',
                                padding: '18px',
                                backgroundColor: '#C0722C',
                                color: 'white',
                                border: 'none',
                                borderRadius: '16px',
                                fontWeight: '800',
                                fontSize: '16px',
                                cursor: 'pointer',
                                boxShadow: '0 10px 20px rgba(192, 114, 44, 0.2)',
                                transition: 'all 0.3s ease'
                            }}
                            onMouseOver={(e) => { e.currentTarget.style.backgroundColor = '#2C1A10'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
                            onMouseOut={(e) => { e.currentTarget.style.backgroundColor = '#C0722C'; e.currentTarget.style.transform = 'translateY(0)'; }}
                        >
                            {isEditing ? 'Synchronize Identity Registry' : 'Confirm Personnel Onboarding'}
                        </button>
                    </form>
                )}
            </SlidingDrawer>

            <div style={{ backgroundColor: 'white', borderRadius: '28px', boxShadow: '0 15px 45px rgba(0,0,0,0.03)', overflow: 'hidden', border: '1px solid #F0F0F0' }}>
                <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: '0', textAlign: 'left' }}>
                    <thead style={{ backgroundColor: '#FDF8F3' }}>
                        <tr style={{ color: '#888', fontSize: '11px', fontWeight: '800', textTransform: 'uppercase', letterSpacing: '1.5px' }}>
                            <th style={{ padding: '25px 30px' }}>Dignitary Identity</th>
                            <th style={{ padding: '25px 30px' }}>Classification</th>
                            <th style={{ padding: '25px 30px' }}>Clearance Status</th>
                            <th style={{ padding: '25px 30px', textAlign: 'right' }}>Directives</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr><td colSpan="4" style={{ padding: '60px', textAlign: 'center', color: '#888', fontWeight: '600' }}>SYNCHRONIZING REPOSITORY...</td></tr>
                        ) : users.length === 0 ? (
                            <tr>
                                <td colSpan="4" style={{ padding: '100px 40px', textAlign: 'center' }}>
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>
                                        <div style={{
                                            width: '120px',
                                            height: '120px',
                                            backgroundColor: '#FDF8F3',
                                            borderRadius: '45px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: '#C0722C',
                                            marginBottom: '30px'
                                        }}>
                                            <svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></svg>
                                        </div>
                                        <h3 style={{ color: '#2C1A10', margin: '0 0 12px 0', fontSize: '24px', fontWeight: '800' }}>No Personnel Records Found</h3>
                                        <p style={{ color: '#888', fontSize: '16px', margin: 0, maxWidth: '350px', lineHeight: '1.6' }}>
                                            The legislative database currently holds no entries for "<strong>{filter}</strong>".
                                        </p>
                                        <button
                                            onClick={() => setFilter('')}
                                            style={{
                                                marginTop: '35px',
                                                padding: '14px 28px',
                                                backgroundColor: 'transparent',
                                                border: '2px solid #C0722C',
                                                color: '#C0722C',
                                                borderRadius: '16px',
                                                fontWeight: '700',
                                                cursor: 'pointer'
                                            }}
                                        >
                                            Reset Search Registry
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        ) : (
                            users.map(user => (
                                <tr key={user._id} style={{ borderBottom: '1px solid #F5F5F5', transition: 'background 0.2s' }}>
                                    <td style={{ padding: '25px 30px' }}>
                                        <div style={{ fontSize: '17px', fontWeight: '800', color: '#2C1A10' }}>{user.firstName} {user.lastName}</div>
                                        <div style={{ fontSize: '13px', color: '#888', marginTop: '6px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            <span style={{ display: 'flex' }}>{ICONS.id}</span>
                                            {user.email}
                                        </div>
                                    </td>
                                    <td style={{ padding: '25px 30px' }}>
                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '8px' }}>
                                            <span style={{
                                                padding: '6px 14px',
                                                borderRadius: '10px',
                                                backgroundColor: user.designation === 'SuperAdmin' ? '#2C1A10' : '#FFF5EB',
                                                color: user.designation === 'SuperAdmin' ? '#EAD7BB' : '#C0722C',
                                                fontSize: '11px',
                                                fontWeight: '800',
                                                textTransform: 'uppercase',
                                                letterSpacing: '1px',
                                                border: `1px solid ${user.designation === 'SuperAdmin' ? '#2C1A10' : '#F5DCC8'}`
                                            }}>
                                                {user.designation}
                                            </span>
                                            {user.party || user.department ? (
                                                <div style={{ fontSize: '13px', fontWeight: '600', color: '#666', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                    <span style={{ width: '6px', height: '6px', borderRadius: '50%', backgroundColor: '#C0722C' }}></span>
                                                    {user.party || user.department}
                                                </div>
                                            ) : null}
                                        </div>
                                    </td>
                                    <td style={{ padding: '25px 30px' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <div style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: user.isActive ? '#2E7D32' : '#D32F2F', boxShadow: `0 0 10px ${user.isActive ? '#2E7D3280' : '#D32F2F80'}` }}></div>
                                            <span style={{ color: user.isActive ? '#2E7D32' : '#D32F2F', fontWeight: '800', fontSize: '13px', textTransform: 'uppercase', letterSpacing: '1px' }}>
                                                {user.isActive ? 'Authorized' : 'Revoked'}
                                            </span>
                                        </div>
                                    </td>
                                    <td style={{ padding: '25px 30px', textAlign: 'right', display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                                        <button
                                            onClick={() => user.designation !== 'SuperAdmin' && handleEdit(user)}
                                            style={{
                                                padding: '12px',
                                                backgroundColor: '#FDF8F3',
                                                color: '#C0722C',
                                                border: '1px solid #F0E8DB',
                                                borderRadius: '12px',
                                                cursor: user.designation === 'SuperAdmin' ? 'not-allowed' : 'pointer',
                                                transition: 'all 0.2s',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                opacity: user.designation === 'SuperAdmin' ? 0.5 : 1
                                            }}
                                            disabled={user.designation === 'SuperAdmin'}
                                            title="Edit Profile"
                                        >
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>
                                        </button>
                                        <button
                                            onClick={() => user.designation !== 'SuperAdmin' && toggleStatus(user)}
                                            style={{
                                                padding: '12px 24px',
                                                backgroundColor: user.isActive ? '#FFF8F8' : '#F4FBF5',
                                                color: user.isActive ? '#D32F2F' : '#2E7D32',
                                                border: 'none',
                                                borderRadius: '12px',
                                                cursor: user.designation === 'SuperAdmin' ? 'not-allowed' : 'pointer',
                                                fontWeight: '800',
                                                fontSize: '11px',
                                                textTransform: 'uppercase',
                                                letterSpacing: '1px',
                                                transition: 'all 0.3s ease',
                                                opacity: user.designation === 'SuperAdmin' ? 0.5 : 1
                                            }}
                                            disabled={user.designation === 'SuperAdmin'}
                                        >
                                            {user.isActive ? 'Revoke Access' : 'Authorize'}
                                        </button>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default UserManagement;
